<template>
  <v-app>
    <NotFound v-if='isNotFound'/>
    <Forbidden v-else-if='isForbidden'/>
    <router-view v-else/>
  </v-app>
</template>

<script>
import Forbidden from '/src/components/pages/errors/Forbidden'
import NotFound from '/src/components/pages/errors/NotFound'
import { mapState, mapGetters } from 'vuex'

export default {
  components: { Forbidden, NotFound },
  computed: {
    ...mapState({
      isForbidden: (state) => state.errorPage.forbidden
    }),
    ...mapGetters({
      isNotFound: 'errorPage/isNotFound'
    })
  }
}
</script>

<style lang="sass">
a
  text-decoration: none
</style>
